import { call, takeLatest, put, } from 'redux-saga/effects';
import { getOrderSummaryRequest, getOrderSummarySuccess, getOrderSummaryFailure, getOrderHistoryRequest, getOrderHistorySuccess, getOrderHistoryFailure, getOrderDownloadRequest, getOrderDownloadSuccess, getOrderDownloadFailure } from '../actions/ordersPageActions';
import { makeOrderSummaryCall, makeOrderHistoryCall } from '../../api/ordersPageAPI';

export function* getOrderSummarySaga(action) {
	try {
	  const response = yield call(makeOrderSummaryCall, action);
	  yield put(getOrderSummarySuccess(response) );
	} catch (e) {
	  yield put(getOrderSummaryFailure(e.message));
	}
}

export function* getOrderHistorySaga(action) {
	try {
		const response = yield call(makeOrderHistoryCall, action);
		yield put(getOrderHistorySuccess(response));
	  } catch (e) {
		yield put(getOrderHistoryFailure(e.response?.data));
	  }
}

export function* getOrderDownloadSaga(action) {
	try {
		const response = yield call(makeOrderHistoryCall, action);
		yield put(getOrderDownloadSuccess(response));
	  } catch (e) {
		yield put(getOrderDownloadFailure(e.response?.data));
	  }
}

function* ordersPageSaga() {
	yield takeLatest(getOrderSummaryRequest, getOrderSummarySaga);
	yield takeLatest(getOrderHistoryRequest, getOrderHistorySaga);
	yield takeLatest(getOrderDownloadRequest, getOrderDownloadSaga);
}

export default ordersPageSaga;
